module.exports = __webpack_public_path__ + "img/symbol_6.e5f64064.png";